import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import SoundAssetKeys from '../SoundAssetKeys';
import { playTitleJingle } from '../SoundManager';
import UIAssetKeys from '../UIAssetKeys';
import MarbleDrop from './MarbleDrop';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';

export default class DropIntroScreen extends Phaser.Scene {
  static get KEY() { return 'DropIntroScreen'; }

  constructor() {
    super({ key: DropIntroScreen.KEY });
  }

  init() {
    this.bg = null;
    this.btnGo = null;
  }

  create() {
    this.bg = this.add.image(0,0,'introbackground').setOrigin(0);

    this.btnGo = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._mm_common_assets_BtnGo, this).setOrigin(0);

    this.btnGo.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.goClick, this);
    this.btnGo.x = this.scale.width + 80;
    this.btnGo.y = this.scale.height - 180;
    this.layoutRatio();

    const centerx = this.scale.width / 2 - this.btnGo.width / 2 - 15;
    ABCyaPhaser.Tweens.addTween(this.btnGo, 800, { x: centerx }, Phaser.Math.Easing.Quadratic.Out, () => this.handleGoReady());
    playTitleJingle(this);
  }

  goClick () {
    this.btnGo.removeAllListeners();
    ABCyaPhaser.Tweens.addTween(this.btnGo,350, { alpha: 0 }, Phaser.Math.Easing.Quadratic.Out, () => this.introFinished());
  }

  layoutRatio () {
    this.btnGo.y = this.scale.height - 180;
  }

  handleGoReady () {
    this.btnGo.setInteractive();
    ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._MarbleDropTitle, this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
  }

  introFinished () {
    this.scene.start(MarbleDrop.KEY);
  }
}